module.exports = __webpack_public_path__ + "img/decimal_swap.f86ba7f7.png";